<template>
  <v-form lazy-validation ref="form_setting" :key="key">
    <div class="d-grid grid-col-sm-1-1 grid-col-md-1-1-1 align-start gap-5">
      <BaseCard :title="localStorage.translations.pages['setting-setting_company'].all['main']">
        <template v-for="(i, j) in fieldGroup[0]">
          <BaseInput
            :key="j"
            :label="localStorage.translations.pages['setting-setting_company'].all[i[0]]"
            v-model="data[i[1] || i[0]]"
            :viewValue="data[i[1] || i[0]] || '-'"
            v-bind="presetBaseInput"
            @input="onInput"
          />
        </template>
        <GoogleAutocomplete
          v-if="edit"
          :title="localStorage.translations.pages['setting-setting_company'].all['company_address_registration']"
          :street="data['registration_address_street']"
          :zip="data['registration_address_zip']"
          :city="data['registration_address_city']"
          :on-change="changeRegistrationAddress"
        />
        <BaseInput
          v-else
          :label="localStorage.translations.pages['setting-setting_company'].all['company_address_registration']"
          :viewValue="(data['registration_address_street'] ? data['registration_address_street'] : '-') +
                  (data['registration_address_zip'] ? ', ' + data['registration_address_zip'] : '') +
                  (data['registration_address_city'] ? ' ' + data['registration_address_city'] : '')"
          :rules="null"
          v-bind="presetBaseInput"
          @input="onInput"
        />
        <GoogleAutocomplete
          v-if="edit"
          :title="localStorage.translations.pages['setting-setting_company'].all['company_address_billing']"
          :street="data['billing_address_street']"
          :zip="data['billing_address_zip']"
          :city="data['billing_address_city']"
          :on-change="changeBillingAddress"
        />
        <BaseInput
          v-else
          :label="localStorage.translations.pages['setting-setting_company'].all['company_address_billing']"
          :viewValue="(data['billing_address_street'] ? data['billing_address_street'] : '-') +
                  (data['billing_address_zip'] ? ', ' + data['billing_address_zip'] : '') +
                  (data['billing_address_city'] ? ' ' + data['billing_address_city'] : '')"
          :rules="null"
          v-bind="presetBaseInput"
          @input="onInput"
        />
      </BaseCard>
      <BaseCard :title="localStorage.translations.pages['setting-client'].tables['elektronnyy-schet-faktura']">
        <template v-for="(i, j) in fieldGroup[1]">
          <BaseInput
            :key="j"
            :label="i[2] ? i[2] : localStorage.translations.pages['setting-client'].tables[i[0]]"
            v-model="data[i[1] || i[0]]"
            :viewValue="data[i[1] || i[0]] || '-'"
            v-bind="presetBaseInput"
            @input="onInput"
          />
        </template>
      </BaseCard>
      <div>
        <BaseCard class="mb-5">
          <BaseInput
            :label="localStorage.translations.pages['setting-personal_area'].labels['elektronnaya-pochta']"
            v-model="data.email"
            :viewValue="data.email || '-'"
            v-bind="presetBaseInput"
            :rules="['required', 'email']"
            @input="onInput"
          />
          <BaseInput
            :label="localStorage.translations.pages['setting-setting_company'].all['email_invoice']"
            v-model="data['laskut_email']"
            :viewValue="data['laskut_email'] || '-'"
            v-bind="presetBaseInput"
            :rules="['required', 'email']"
            @input="onInput"
          />
          <BaseInput
            :label="localStorage.translations.pages['setting-personal_area'].labels['telefon']"
            v-model="data.phone"
            :viewValue="data.phone || '-'"
            v-bind="presetBaseInput"
            @input="onInput"
          />
          <BaseInput
            :label="localStorage.translations.pages['setting-personal_area'].labels['gorod']"
            v-model="data.city"
            :viewValue="data.city || '-'"
            v-bind="presetBaseInput"
            @input="onInput"
          />
        </BaseCard>
        <BaseCard>
          <BaseInput
            :label="localStorage.translations.pages['setting-setting_company'].all['project_number_abbreviation']"
            v-model="data['short_name']"
            :viewValue="data['short_name'] || '-'"
            v-bind="presetBaseInput"
            @input="onInput"
          />
        </BaseCard>
      </div>
    </div>
    <div class="fixedBtn">
      <BaseTooltip v-if="edit" :tooltip="localStorage.translations.pages.common['buttons']['sohranit']">
        <BaseButton
          :disabled="!navigationGuardianActive"
          @click="onSave"
          round icon_only
          size="60"
          default_icon="button-save"
        />
      </BaseTooltip>
      <BaseTooltip v-else :tooltip="localStorage.translations.pages.common['buttons']['redaktirovat']">
        <BaseButton @click="onEdit" round size="60" icon_only default_icon="button-edit"/>
      </BaseTooltip>
    </div>
  </v-form>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import GoogleAutocomplete from "components/google/autocomplete/GoogleAutocomplete";

export default {
  name: 'settingCompanyMainSettings',
  components: {GoogleAutocomplete},
  data: () => ({
    data: {},
    key: 0,
  }),
  computed: {
    ...mapGetters(['companiesConfig']),
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    edit() {
      return this.$route.name === 'SettingCompanyGeneralEdit'
    },
    presetBaseInput() {
      return {
        view: !this.edit,
        rules: ['required'],
      }
    },
    fieldGroup() {
      return [
        [
          ['company_name'],
          ['company_id'],
          ['vat'],
          ['company_director', 'executor']
        ],
        [
          ['adres-elektronnoy-nakladnoy-ovt', 'ovt'],
          ['id-operatora', 'id_operator'],
          ['operator'],
          ['', 'iban', 'IBAN'],
          ['', 'bic', 'BIC']
        ],
      ]
    },
    notification() {
      return this.localStorage.translations.pages.common.notifications
    },
  },
  watch: {
    '$route.name'() {
      this.onCheckChange({overwrite: true})
    },
    companiesConfig() {
      this.getData()
    }
  },
  created() {
    this.onLoadData()
  },
  methods: {
    ...mapActions(['onCompaniesConfig']),
    ...mapActions('commonConfig', ['onCommonConfigSettingsUpdate']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onCheckChange({overwrite}) {
      this.onNavigationGuardianCheck({
        data: {companyMainSettings: this.data},
        overwrite,
      })
    },
    onInput() {
      this.onCheckChange({overwrite: false})
    },
    async onLoadData() {
      await this.onCompaniesConfig()
        .catch(() => {
          this.$store.dispatch(
            'popup/onMessage',
            {message: this.notification['oshibka'], IsError: false},
            {root: true},
          )
        })
    },
    getData() {
      let fields = ['company_name', 'short_name', 'company_id', 'executor', 'registration_address_street',
        'registration_address_zip', 'registration_address_city', 'billing_address_street', 'billing_address_zip',
        'billing_address_city', 'city', 'phone', 'email', 'laskut_email', 'ovt', 'operator', 'id_operator',
        'vat', 'iban', 'bic']
      for (let i in fields)
        this.data[fields[i]] = this.companiesConfig[fields[i]] || ''
      console.log('data', this.data)
      let address = ['registration_address', 'billing_address']
      for (let i in address)
        this.data[address[i]] = this.data[address[i] + '_street'] + ', ' + this.data[address[i] + '_zip'] + ' ' +
          this.data[address[i] + '_city']
      this.key++
      if (this.edit) this.onCheckChange({overwrite: true})
    },
    onEdit() {
      this.$router.push({name: this.edit ? 'SettingCompanyGeneral' : 'SettingCompanyGeneralEdit'})
    },
    async onSave() {
      if (this.$refs.form_setting.validate()) {
        await this.onCommonConfigSettingsUpdate({name: 'account_settings', data: this.data})
          .then(() => {
            this.onCheckChange({overwrite: true})
            this.onEdit()
            this.$store.dispatch(
              'popup/onMessage',
              {message: this.notification['izmeneniya-uspeshno-sohraneny'], IsError: false},
              {root: true},
            )
          })
          .catch(() => {
            this.$store.dispatch(
              'popup/onMessage',
              {message: this.notification['oshibka'], IsError: false},
              {root: true},
            )
          })
      }
    },
    changeRegistrationAddress(data) {
      let field = 'registration_address'
      this.data[field + '_street'] = data.street
      this.data[field + '_zip'] = data.zip
      this.data[field + '_city'] = data.city
      this.data[field] =
        this.data[field + '_street'] + ', ' + this.data[field + '_zip'] + ' ' + this.data[field + '_city']
      this.onInput()
    },
    changeBillingAddress(data) {
      let field = 'billing_address'
      this.data[field + '_street'] = data.street
      this.data[field + '_zip'] = data.zip
      this.data[field + '_city'] = data.city
      this.data[field] =
        this.data[field + '_street'] + ', ' + this.data[field + '_zip'] + ' ' + this.data[field + '_city']
      this.onInput()
    },
  },
}
</script>

<style scoped lang="scss">
.d-grid {
  max-width: 2100px;
}
</style>